/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Floor_Plan_3dInputs */

const cs_enum_floor_plan_3d = /** @type {(inputs: Enum_Floor_Plan_3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Půdorys 3D`)
};

const en_enum_floor_plan_3d = /** @type {(inputs: Enum_Floor_Plan_3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D floor plan`)
};

/**
* | output |
* | --- |
* | "3D floor plan" |
*
* @param {Enum_Floor_Plan_3dInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_floor_plan_3d = /** @type {((inputs?: Enum_Floor_Plan_3dInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Floor_Plan_3dInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_floor_plan_3d(inputs)
	return cs_enum_floor_plan_3d(inputs)
});